module.exports = __webpack_public_path__ + "img/ptt2.42d67f6a.gif";